export default "__VITE_ASSET__mfYiABYa__"